import { isFedRamp } from '@atlassian/atl-context';

import { fg } from '@confluence/feature-gating';
import { useSessionDataWithRovoExperiment } from '@confluence/session-data';

export const useAIRovoButtonEnablement = () => {
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useSessionDataWithRovoExperiment();
	return !isFedRamp() && isAdminHubAIEnabled && isRovoLLMEnabled && fg('ai-smart-button-team-25');
};
